<template>
  <div class="wrapper">
    <Menu />
    <Header hideMore title="Haberler" />
    <div class="body-area pt70">
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 p-0"
            v-for="item in $store.state.news"
            :key="item.slug"
            @click="getNews(item.slug)"
          >
            <div class="item-box">
              <div class="box-header p-0">
                <img :src="item.thumb_960" class="w-100" />
              </div>
              <div class="box-title">
                <h1 class="fc-2 fs-20 pb-3">{{item.title}}</h1>
                <div class="row">
                  <div class="col-6">
                    <span class="fs-12 fc-3">{{item.date}}</span>
                  </div>
                  <div class="col-6 text-right">
                    <span class="fs-12 fc-3" v-if="item.comment_count != 0">
                      <img src="/static/img/comments-icon.svg" class="mr-2" />
                      {{item.comment_count}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <infinite-loading @infinite="getData"></infinite-loading>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "News",
  components: {
    Footer,
    Menu,
    Header,
    InfiniteLoading
  },
  beforeMount() {
    axios.get("haber?sayfa=" + 1).then(res => {
      this.$store.state.news = this.$store.state.news.concat(res.data.data);
    });
  },
  data() {
    return {
      filter: {
        page: 1
      },
      items: [],
      more: true,
      loading: true
    };
  },
  methods: {
    getData($state) {
      this.loading = true;
      this.filter.page += 1;
      axios.get("haber?sayfa=" + this.filter.page).then(res => {
        if (res.data.data.length == 0) {
          $state.complete();
        } else {
          $state.loaded();
          this.$store.state.news = this.$store.state.news.concat(res.data.data);
        }
      });
    },
    getNews(slug) {
      this.$store.state.loading = true;
      axios.get("/haber/detay?slug=" + slug).then(res => {
        this.$store.state.loading = false;
        this.$router.push({
          name: "NewsDetail",
          params: { data: res.data.data, slug }
        });
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/News.vue